import { render, staticRenderFns } from "./SourceField.vue?vue&type=template&id=37a05ee9&"
import script from "./SourceField.vue?vue&type=script&lang=js&"
export * from "./SourceField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports